"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterItemHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _CurrencyFormat = _interopRequireDefault(require("../../../CurrencyFormat"));
// Components:

var FilterItemHeader = exports.FilterItemHeader = function FilterItemHeader(props) {
  var hasTours = props.hasTours,
    name = props.name,
    minPrice = props.minPrice;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var _useCurrency = (0, _localization.useCurrency)(),
    code = _useCurrency.code;
  return /*#__PURE__*/_react["default"].createElement(StyledCheckboxTop, null, /*#__PURE__*/_react["default"].createElement(StyledCheckboxName, {
    disabled: !hasTours
  }, name), hasTours && /*#__PURE__*/_react["default"].createElement(StyledCheckboxPrice, null, /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.filters.price'), "\xA0"), /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    value: minPrice,
    currencyCode: code
  })));
};
var StyledCheckboxTop = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemHeader__StyledCheckboxTop",
  componentId: "sc-15mhw2t-0"
})(["display:flex;flex-direction:row;"]);
var StyledCheckboxName = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemHeader__StyledCheckboxName",
  componentId: "sc-15mhw2t-1"
})(["max-width:225px;font-size:14px;font-style:normal;font-weight:400;line-height:16px;color:var(--black);"]);
var StyledCheckboxPrice = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemHeader__StyledCheckboxPrice",
  componentId: "sc-15mhw2t-2"
})(["margin-left:auto;padding-left:5px;display:flex;align-items:center;font-size:14px;line-height:16px;font-style:normal;font-weight:500;color:var(--black);"]);